export const isStoreCodeValid = (value = '') => /^(05|82|08)([0-9]{4,4})$/.test(value);
